// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__KFuJy","inputDescription":"styles_inputDescription__10mqI"};